export default "__VITE_ASSET__DF3rW9ER__"